import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { newTicketContext, newTicketSchema, INewTicket } from './NewTicketContext';
import { NewTicketForm } from './components';
import { applicationContext,appUserContext } from 'helpers/services';

let NewTicket = () => {
    let { currentUser } = useContext(appUserContext);
    let { isSaving, saveTicket } = useContext(newTicketContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="New ticket"
                isLoading={false}
            >
                <Formik
                    validationSchema={newTicketSchema}
                    initialValues={{
                        ...newTicketSchema.getDefault(),
                        reporter: currentUser?.typology === "Customer" ? currentUser.email : ''
                    }}
                    onSubmit={(values, action) => {
                        saveTicket(values);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <NewTicketForm isSaving={isSaving} />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default NewTicket;